import { TYPE_TOGGLE_SIDEBAR } from "app/redux/chats&notifications/chatsTypes";

export const actionToggleSidebar = {
  type: TYPE_TOGGLE_SIDEBAR,
}
